/* Quiet Performance: native Shopify forms, small progressive enhancements. */
(() => {
  'use strict';
  if (window.quietPerformance) return;
  window.quietPerformance = true;
  document.documentElement.classList.add('js');

  const announce = (message) => {
    const status = document.getElementById('StoreStatus');
    if (status) status.textContent = message;
  };
  const safeURL = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && /^https?:$/.test(url.protocol) ? url.href : '';
    } catch { return ''; }
  };
  // Shopify media lives on the CDN, so gallery links may be cross-origin https.
  const safeURLAny = (value) => {
    try { const url = new URL(value, window.location.origin); return /^https?:$/.test(url.protocol) ? url.href : ''; } catch { return ''; }
  };
  const catalogItem = (item) => item && typeof item.title === 'string' && safeURL(item.url) && (typeof item.id === 'number' || typeof item.id === 'string');
  let compared = [];
  try { compared = JSON.parse(sessionStorage.getItem('lv-compare') || '[]'); } catch { /* Session storage is optional. */ }
  if (!Array.isArray(compared)) compared = [];
  compared = compared.filter(catalogItem).slice(0, 3);
  const events = new EventTarget();
  const labels = () => {
    try { return JSON.parse(document.querySelector('[data-compare-labels]')?.textContent || '{}'); } catch { return {}; }
  };
  const syncButtons = () => {
    document.querySelectorAll('[data-compare-toggle]').forEach((button) => {
      try {
        const item = JSON.parse(button.dataset.product);
        const selected = compared.some((saved) => String(saved.id) === String(item.id));
        button.setAttribute('aria-pressed', String(selected));
        const off = button.querySelector('[data-compare-label-off]');
        const on = button.querySelector('[data-compare-label-on]');
        if (off && on) { off.hidden = selected; on.hidden = !selected; }
      } catch { button.hidden = true; }
    });
  };
  const save = () => {
    const feedback = document.querySelector('[data-compare-feedback]');
    if (feedback) feedback.hidden = true;
    try { sessionStorage.setItem('lv-compare', JSON.stringify(compared)); } catch { /* Memory state still works. */ }
    syncButtons();
    events.dispatchEvent(new Event('change'));
  };
  const remove = (id) => { compared = compared.filter((item) => String(item.id) !== String(id)); save(); };
  const toggle = (item) => {
    const text = labels();
    if (!catalogItem(item)) return;
    if (compared.some((saved) => String(saved.id) === String(item.id))) {
      remove(item.id); announce(text.removed || '');
    } else if (compared.length < 3) {
      compared.push(item); save(); announce(text.added || '');
    } else {
      announce(text.limit || '');
      const feedback = document.querySelector('[data-compare-feedback]');
      if (feedback) { feedback.textContent = text.limit; feedback.hidden = false; }
    }
  };

  class CompareTray extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.dialog = this.querySelector('dialog');
      this.querySelector('[data-compare-open]')?.addEventListener('click', (event) => {
        this.opener = event.currentTarget;
        this.renderTable();
        this.dialog.showModal();
      }, { signal });
      this.querySelector('[data-compare-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
      this.querySelector('[data-compare-clear]')?.addEventListener('click', () => {
        compared = []; save();
      }, { signal });
      this.dialog?.addEventListener('close', () => this.opener?.focus(), { signal });
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      }, { signal });
      this.querySelector('[data-compare-diff]')?.addEventListener('change', (event) => {
        this.querySelector('.compare-table')?.classList.toggle('diff-only', event.target.checked);
      }, { signal });
      events.addEventListener('change', () => this.update(), { signal });
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); }
    update() {
      this.hidden = compared.length === 0;
      this.querySelector('[data-compare-count]').textContent = String(compared.length);
      if (this.dialog?.open) {
        if (!compared.length) this.dialog.close();
        else this.renderTable();
      }
    }
    renderTable() {
      const text = labels();
      const table = document.createElement('table');
      table.className = 'compare-table';
      if (this.querySelector('[data-compare-diff]')?.checked) table.classList.add('diff-only');
      const tbody = document.createElement('tbody');
      const row = (label, makeCell, options = {}) => {
        const tr = document.createElement('tr');
        if (options.className) tr.className = options.className;
        const th = document.createElement('th');
        th.scope = 'row'; th.textContent = label; tr.append(th);
        compared.forEach((item) => { const td = document.createElement('td'); makeCell(td, item); tr.append(td); });
        for (let i = compared.length; i < 3; i += 1) {
          const td = document.createElement('td'); td.className = 'compare-empty';
          if (options.className === 'compare-head') td.textContent = text.empty_slot || '';
          tr.append(td);
        }
        tbody.append(tr);
        return tr;
      };
      row(text.name, (cell, item) => {
        if (item.image) {
          const imageURL = new URL(item.image, window.location.origin);
          if (/^https?:$/.test(imageURL.protocol)) {
            const image = document.createElement('img');
            image.src = imageURL.href; image.alt = ''; image.width = 220; image.height = 110; cell.append(image);
          }
        }
        const vendor = document.createElement('span'); vendor.className = 'eyebrow'; vendor.textContent = item.vendor || ''; cell.append(vendor);
        const heading = document.createElement('h3'); heading.textContent = item.title; cell.append(heading);
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'compare-remove'; button.textContent = text.remove;
        button.setAttribute('aria-label', `${text.remove}: ${item.title}`);
        button.addEventListener('click', () => { remove(item.id); if (this.dialog.open) this.querySelector('[data-compare-close]').focus(); });
        cell.append(button);
      }, { className: 'compare-head' });
      row(text.price, (cell, item) => { const price = document.createElement('strong'); price.className = 'price'; price.textContent = `${item.varies ? `${text.from} ` : ''}${item.price}`; cell.append(price); }, { className: 'compare-price' });
      const specRows = [
        ['gpu', (item) => item.gpu],
        ['architecture', (item) => item.architecture],
        ['memory', (item) => item.memory],
        ['cooling', (item) => item.cooling],
        ['length', (item) => item.length],
        ['slot', (item) => item.slot],
        ['power', (item) => item.power],
        ['connectors', (item) => item.connectors],
        ['outputs', (item) => item.outputs],
        ['interface', (item) => item.interface],
        ['oc', (item) => item.oc],
        ['condition', (item) => item.condition],
        ['availability', (item) => (item.available ? text.available : text.sold_out)]
      ];
      specRows.forEach(([key, read]) => {
        const values = compared.map((item) => { const value = read(item); return value === undefined || value === null || value === '' ? '—' : String(value); });
        const differs = compared.length > 1 && new Set(values).size > 1;
        const tr = row(text[key], (cell, item) => { cell.textContent = values[compared.indexOf(item)]; }, { className: differs ? 'is-different' : '' });
        if (differs) tr.title = text.differs || '';
      });
      row('', (cell, item) => { const link = document.createElement('a'); link.href = safeURL(item.url); link.textContent = `${text.view} ↗`; cell.append(link); }, { className: 'compare-foot' });
      table.append(tbody);
      this.querySelector('[data-compare-table]').replaceChildren(table);
    }
  }
  customElements.define('compare-tray', CompareTray);

  // Product gallery: a scroll-snap carousel (swipe, arrows, thumbnails, arrow keys) that also works without JavaScript.
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const track = this.querySelector('[data-gallery-track]');
      if (!track) return;
      const slides = [...track.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
      const counter = this.querySelector('[data-gallery-counter]');
      const smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      let index = Math.max(0, slides.findIndex((slide) => slide.hasAttribute('data-current')));
      const strip = thumbs[0]?.parentElement;
      const sync = () => {
        slides.forEach((slide, i) => slide.toggleAttribute('data-current', i === index));
        thumbs.forEach((thumb) => {
          if (Number(thumb.dataset.index) === index) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
        });
        if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
      };
      // Keep the active thumbnail in view once the carousel has settled; scrolling the strip
      // during the carousel's own smooth scroll would cancel that scroll.
      const followThumb = () => {
        const thumb = thumbs.find((item) => Number(item.dataset.index) === index);
        if (!thumb || !strip || strip.scrollWidth <= strip.clientWidth + 1) return;
        strip.scrollTo({ left: thumb.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2, behavior: smooth });
      };
      const goTo = (target, behavior = smooth) => {
        index = (target + slides.length) % slides.length;
        track.scrollTo({ left: index * track.clientWidth, behavior });
        sync();
      };
      let settle;
      track.addEventListener('scroll', () => {
        const seen = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (seen !== index && seen >= 0 && seen < slides.length) { index = seen; sync(); }
        clearTimeout(settle); settle = setTimeout(followThumb, 160);
      }, { signal, passive: true });
      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => goTo(index - 1), { signal });
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => goTo(index + 1), { signal });
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-gallery-thumb]');
        if (!thumb || !this.contains(thumb)) return;
        event.preventDefault();
        goTo(Number(thumb.dataset.index) || 0);
      }, { signal });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); goTo(index + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(index - 1); }
      }, { signal });
      if (index > 0) goTo(index, 'auto'); else sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('product-gallery', ProductGallery);

  // Related cards come from Shopify's recommendations endpoint, rendered by this theme's own section.
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = safeURL(this.dataset.url);
      if (!url || this.querySelector('.related-section')) return;
      const load = () => fetch(url).then((response) => (response.ok ? response.text() : ''))
        .then((html) => {
          const section = new DOMParser().parseFromString(html, 'text/html').querySelector('product-recommendations .related-section');
          if (!section) return;
          this.replaceChildren(section);
          syncButtons();
        })
        .catch(() => { /* The page is complete without recommendations. */ });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect(); load();
        }, { rootMargin: '400px 0px' });
        observer.observe(this);
      } else { load(); }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  document.addEventListener('click', (event) => {
    const compareButton = event.target.closest('[data-compare-toggle]');
    if (compareButton) { try { toggle(JSON.parse(compareButton.dataset.product)); } catch { /* Invalid catalog data is ignored. */ } }
    const qtyButton = event.target.closest('[data-qty]');
    const qtyInput = qtyButton?.closest('[data-quantity]')?.querySelector('input');
    if (qtyInput) {
      const step = Number(qtyInput.step) || 1;
      const min = Number(qtyInput.min) || 1;
      const max = qtyInput.max ? Number(qtyInput.max) : Infinity;
      const next = (Number(qtyInput.value) || min) + step * Number(qtyButton.dataset.qty);
      qtyInput.value = String(Math.min(max, Math.max(min, next)));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const menuLink = event.target.closest('.mobile-nav a');
    if (menuLink) menuLink.closest('details').open = false;
    document.querySelectorAll('.filter-disclosure[open],.mobile-menu[open]').forEach((details) => { if (!details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mobile-menu[open],.filter-disclosure[open]').forEach((details) => {
      details.open = false; details.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-submit-change]')) event.target.form?.requestSubmit();
  });
  // The browser posts directly to Shopify. Never retry a cart request automatically.
  document.addEventListener('submit', (event) => {
    if (event.defaultPrevented) return;
    const form = event.target;
    if (!form.matches('.product-form,.cart-form')) return;
    if (form.dataset.submitting === 'true') { event.preventDefault(); return; }
    form.dataset.submitting = 'true';
    event.submitter?.setAttribute('aria-disabled', 'true');
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-submitting]').forEach((form) => {
      delete form.dataset.submitting; form.querySelectorAll('[aria-disabled]').forEach((button) => button.removeAttribute('aria-disabled'));
    });
    syncButtons();
  });
  document.addEventListener('shopify:section:load', syncButtons);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if ('IntersectionObserver' in window && !reducedMotion.matches && !window.Shopify?.designMode) {
    const onReveal = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        }
      });
    };
    const revealObserver = new IntersectionObserver(onReveal, { threshold: 0.06 });
    // Product grids can be taller than the viewport, so any visible part starts their staggered reveal.
    const gridObserver = new IntersectionObserver(onReveal, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    const observerFor = (element) => (element.matches('.product-grid') ? gridObserver : revealObserver);
    const reveal = (root) => root.querySelectorAll('[data-reveal]:not(.will-reveal)').forEach((element) => {
      element.classList.add('will-reveal'); observerFor(element).observe(element);
    });
    reveal(document);
    document.addEventListener('shopify:section:load', (event) => reveal(event.target));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-reveal]').forEach((element) => observerFor(element).unobserve(element)));
  }
  syncButtons();
})();
